import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@Env/environment';

import { Evaluation } from '../index';
import {DaoGeneric} from '@Services/base/daoService';
import {Observable, of} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class EvaluationService  extends DaoGeneric<Evaluation> {
  private url = `${environment.baseUrl}/api_bdc/evaluations/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

  updateOrCreate(evaluation: Evaluation) {
    return ('id' in evaluation && evaluation.id > 0) ? this.update(evaluation) : this.create(evaluation);
  }

  getByPageAndUser(page = null, user = null): Observable<Evaluation> {
    if (page && user) {
      const extraParams: Map<string, string> = new Map<string, string>();
      extraParams.set('page', page).set('user', user);
      const params = this._getUrlHttpParams(extraParams);

      const url = `${this.url}by_page_user/`;
      return this.httpClient.get<Evaluation>(url, { params: params});
    }

    return of(null);
  }

  // list(
  //   offset: number = 0,
  //   limit: number = 0,
  //   keyword: string = '',
  //   user: number = null,
  //   page: number = null,
  //   ordering: string = '',
  // ) {
  //   const params = getParams(limit, offset, keyword, ordering, {
  //     'user': user,
  //     'page': page
  //   });
  //   return this.http.get<Evaluation[]>(this.url);
  // }
}
